export default "__VITE_ASSET__BBwNTEua__"